/* src/app/views/template/components/edit-template-menu-section/edit-template-menu-section-footer/edit-template-menu-section-footer.component.scss */
/*# sourceMappingURL=edit-template-menu-section-footer.component.css.map */
